export default "__VITE_ASSET__CUAUD4oQ__"